import {categories} from '../../services/data'

const state = {
    selected: [],
    categories: categories,
    currentCategory: 'Mug'

};

// getters
const getters = {
    getSelectedImage(state) {
        const result = [];
        const selected = state.selected || [];
        const categories = state.categories;
        categories.map(e => {
            e.images.map(e => {
                if (selected.includes(e.id)) {
                    result.push(require('../../assets/' + e.src))
                }
            })
        });
        return result;
    },
    getLengthSelected(state) {
        return state.selected.length;
    },
    getCategories(state) {
        return state.categories.map(e => e.name);
    },
    getCurrentImages(state) {
        return state.categories.find(e => e.name === state.currentCategory);

    }
};

// actions
const actions = {
    setSelectImage({state, commit}, index) {

        let result = [];
        if (state.selected.includes(index)) {
            result = state.selected.filter(i => i !== index)
        } else {
            const s = state.selected;
            s.push(index);
            result = s;
        }
        commit('setSelected', result)
    },
    checkDifferentCategory({state}, categoryName, imageId) {
        let firstCategory = null;
        const firstId = state.selected[0];
        if (firstId === undefined) return false;
        state.categories.map(e => {
            e.images.map(v => {
                if (v.id === firstId) {
                    firstCategory = e.name;
                }
            })
        });
        return firstCategory !== categoryName && firstId !== imageId;
    },
    clearSelected({commit}) {
        commit("clearSelected")
    }
};

// mutations
const mutations = {
    setSelected(state, value) {
        state.selected = value;
    },
    clearSelected(state) {
        state.selected = []
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
